import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'showLastModified',
  pure: true,
})
export class ShowLastModifiedPipe implements PipeTransform {
  public transform(
    lastModifiedDate: string | null,
    lastLoggedInDate: string | null,
  ): boolean {
    if (!lastModifiedDate || !lastLoggedInDate) return false;

    const lastModified = new Date(lastModifiedDate);
    const lastLoggedIn = new Date(lastLoggedInDate);
    return this._isValidLastModifiedDate(lastModified, lastLoggedIn);
  }

  private _isValidLastModifiedDate(
    lastModified: Date,
    lastLoggedIn: Date,
  ): boolean {
    const now = new Date();
    const lastModifiedDiff = now.getTime() - lastModified.getTime();
    const diffInDays = lastModifiedDiff / (24 * 60 * 60 * 1000);

    if (diffInDays > 0 && diffInDays < 14) {
      return true;
    }

    return lastModified.getTime() >= lastLoggedIn.getTime();
  }
}
